<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-5">
            <div class="header-content">Demographic Data</div>
            <div class="sub-content mt-3">
                Hello. Here, you can view the demographic details submitted by service users via the Help Us page.
            </div>
        </div>
        <div class="col-5 d-flex">
            <div class="input-group">
                <input class="form-control py-2 border-0" type="text" placeholder="Search by name, email or city"
                    style="background:#F6FAFA;" [(ngModel)]="searchQuery" (keydown.enter)="searchInList()">
                <span class="input-group-append">
                    <button class="btn btn-outline-secondary border-0 pb-0" *ngIf="searchQuery" (click)="clearSearch()"
                        type="button" style="height: calc(1.5em + 0.75rem + 2px);background:#F6FAFA;">
                        <mat-icon class="font-18 m-auto">clear</mat-icon>
                    </button>
                </span>
                <span class="input-group-append">
                    <button class="btn btn-outline-secondary border-0" (click)="searchInList()" type="button"
                        style="height: calc(1.5em + 0.75rem + 2px);border-left:1px solid #ced4da !important;background:#F6FAFA;">
                        <mat-icon>search</mat-icon>
                    </button>
                </span>
            </div>
        </div>
        <div class="col-1"></div>
    </div>

    <div class="row ml-0 mt-4 align-items-center">
        <div class="col-1"></div>
        <div class="col-6">
            <div class="d-flex">
                <div class="primary-txt font-15">Demographic Data —</div>
                <div class="pl-2">
                    <span *ngIf="isSearched">{{searchCount}} /</span>
                    <span class="primary-txt"> {{totalCount}}</span>
                </div>
            </div>
        </div>
        <div class="col-4 d-flex justify-content-end align-items-center pagination-controls">
            <button class="btn btn-sm btn-outline-secondary mr-3 d-flex align-items-center" [disabled]="!displayCount"
                (click)="downloadCsv()" type="button">
                <mat-icon class="font-18 mr-1">file_download</mat-icon>
                <span class="font-13">Download CSV</span>
            </button>
            <button class="btn btn-sm btn-icon" [disabled]="currentPage === 0" (click)="prevPage()">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="mx-3 font-13">Page {{currentPage + 1}} of {{totalPages}}</span>
            <button class="btn btn-sm btn-icon" [disabled]="currentPage >= totalPages - 1" (click)="nextPage()">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        <div class="col-1"></div>
    </div>
</div>

<div class="row ml-0 mt-3">
    <div class="col-1"></div>
    <div class="col-10 table-scroll-container">
        <table class="table table-hover mb-0">
            <colgroup>
                <col style="width: 16%">
                <col style="width: 20%">
                <col style="width: 6%">
                <col style="width: 11%">
                <col style="width: 11%">
                <col style="width: 10%">
                <col style="width: 13%">
                <col style="width: 13%">
            </colgroup>
            <thead>
                <tr>
                    <th>Pseudo Name</th>
                    <th>Email</th>
                    <th>Age</th>
                    <th>Gender</th>
                    <th>City</th>
                    <th>Sexuality</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let entry of dataList">
                    <tr>
                        <td class="text-truncate">{{ entry.pseudo_name || '—' }}</td>
                        <td class="text-truncate">{{ entry.email_id || '—' }}</td>
                        <td>{{ entry.age || '—' }}</td>
                        <td>{{ entry.gender || '—' }}</td>
                        <td>{{ entry.city || '—' }}</td>
                        <td>{{ entry.sexuality || '—' }}</td>
                        <td>{{ entry.created_at ? formatDateIST(entry.created_at) : '—' }}</td>
                        <td>{{ entry.updated_at ? formatDateIST(entry.updated_at) : '—' }}</td>
                    </tr>
                </ng-container>
                <tr *ngIf="!dataList.length">
                    <td colspan="8" class="text-center sub-content py-5">No demographic data found.</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-1"></div>
</div>
